<template>
  <v-toolbar flat dense class="px-0 mx-0" color="#F4F1DE" max-height="48px">
    <v-toolbar-title>
        <v-img src="@/assets/icons/everhost_v3_logo.svg" contain max-height="50px" width="190px" class="ma-0 pa-0"></v-img>
    </v-toolbar-title>
    <v-divider vertical inset></v-divider>

    <v-spacer/>
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          small
          class="publish-toggle text-none"
          :loading="publishing"
          :disabled="publishing"
          v-bind="attrs"
          v-on="on"
          @click="onPublishClick"
        >{{ message.text }}</v-btn>
      </template>
      <span v-html="message.toolTip"></span>
    </v-tooltip>    
    <v-btn 
      icon
      @click="logout"
      >
        <v-icon>mdi-logout</v-icon>  
    </v-btn>

    <v-dialog v-model="showShareDialog" max-width="420">
      <v-card class="pa-4 text-center">
        <v-card-title class="justify-center pb-1">
          Share your guidebook
        </v-card-title>
        <v-card-text class="pt-2">
          <p class="mb-4">
            Guests can scan this QR code or open the link to view your
            guidebook. Add it to your listing, print it for the property, or
            text it to arriving guests.
          </p>
          <img
            v-if="guidebookUrl"
            :src="qrCodeSrc"
            alt="Guidebook QR code"
            width="220"
            height="220"
            class="mx-auto mb-4 d-block"
          />
          <v-text-field
            :value="guidebookUrl"
            outlined
            dense
            readonly
            hide-details
            append-icon="mdi-content-copy"
            @click:append="copyGuidebookUrl"
            @focus="$event.target.select()"
          />
          <p v-if="copied" class="success--text text-caption mt-2 mb-0">
            Link copied to your clipboard.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            color="error"
            :loading="publishing"
            @click="unpublishGuidebook"
          >
            Unpublish
          </v-btn>
          <v-spacer />
          <v-btn text @click="showShareDialog = false">Close</v-btn>
          <v-btn color="primary" @click="copyGuidebookUrl">Copy link</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import mixins from '@/mixins'
import ehcButtonSmall from './ehc-button-small.vue'

export default {
  components: { ehcButtonSmall },
  props: ['message'],
  mixins: [mixins],
  data() {
    return {
      publishing: false,
      showShareDialog: false,
      copied: false,
    }
  },
  computed: {
    guidebookUrl() {
      const propertyId = this.$store.getters.propertyId
      const baseUrl = this.$store.getters.baseUrl || 'https://everhost.io/'
      if (!propertyId) return ''
      return `${baseUrl}${propertyId}`
    },
    qrCodeSrc() {
      if (!this.guidebookUrl) return ''
      return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(
        this.guidebookUrl,
      )}`
    },
  },
  methods: {
    logout: function(){
      this.$store.dispatch("logout")
      this.goToRoute("Home")
    },
    async onPublishClick() {
      const property = this.$store.getters.property
      if (!property || !property.propertyId || this.publishing) return

      if (property.publishedAt) {
        await this.setPublished(false)
        return
      }

      const published = await this.setPublished(true)
      if (published) {
        this.openShareDialog()
      }
    },
    openShareDialog() {
      this.copied = false
      this.showShareDialog = true
    },
    async copyGuidebookUrl() {
      if (!this.guidebookUrl) return
      try {
        await navigator.clipboard.writeText(this.guidebookUrl)
        this.copied = true
      } catch (error) {
        console.error("copyGuidebookUrl failed", error)
        this.$store.commit("setAlertMessage", "Could not copy the link. Please copy it from the field.")
        this.$store.commit("setShowAlert", true)
      }
    },
    async unpublishGuidebook() {
      const unpublished = await this.setPublished(false)
      if (unpublished) {
        this.showShareDialog = false
      }
    },
    async setPublished(willPublish) {
      const property = this.$store.getters.property
      if (!property || !property.propertyId || this.publishing) return false

      this.publishing = true
      try {
        await this.$store.dispatch("markPropertyPublishedAt", {
          propertyId: property.propertyId,
          publishedAt: willPublish,
        })
        await this.$store.dispatch("getProperty")
        this.$store.commit(
          "setAlertMessage",
          willPublish
            ? "Guidebook published — anyone can view it."
            : "Guidebook unpublished — only you can view it."
        )
        this.$store.commit("setShowAlert", true)
        return true
      } catch (error) {
        console.error("setPublished failed", error)
        this.$store.commit(
          "setAlertMessage",
          "Failed to update publish status. Please try again."
        )
        this.$store.commit("setShowAlert", true)
        return false
      } finally {
        this.publishing = false
      }
    },
  },
  created(){
    this.$store.dispatch('getProperties')
  }
  
}
</script>

<style lang="postcss" scoped>
.divider {
  border-width: 1px !important;
  border-color: white !important;
  height: 100%;
}

.publish-toggle {
  letter-spacing: normal;
  font-weight: 500;
  min-width: 0;
  padding-left: 8px;
  padding-right: 8px;
}
</style>